// LIBRARIES
import styled from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";

// MISC
import { BOXSHADOW, COLORS, FONTS } from "constants/styleVariables";

export const LanguageContainer = styled.div`
  position: absolute;
  border-radius: 20px;
  right: 3.5%;
  top: 13%;
  max-height: 200px;
  width: 400px;
  padding: 20px;
  background: ${COLORS.primaryWhite};
  display: flex;
  flex-direction: column;
  box-shadow: ${BOXSHADOW.containerBoxShadow};

  :after {
    content: "";
    position: absolute;
    top: 0;
    left: 85%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-bottom-color: ${COLORS.primaryWhite};
    border-top: 0;
    margin-left: -20px;
    margin-top: -20px;
  }
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 22px;
  right: 17px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const Title = styled.text`
  font-size: 22px;
  font-family: ${FONTS.newsharp};
  font-weight: bold;
  color: ${COLORS.terraCotta};
  margin-bottom: 25px;
`;

export const Bar = styled.div`
  padding-top: 1px;
  background-color: ${COLORS.thirdGray};
  margin: 10px 0;
`;

export const LanguageType = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

export const LanguageFlagIcon = styled.img`
  margin-right: 10px;
`;

export const LanguageName = styled.text`
  font-size: 14px;
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  margin-top: 2px;
`;
